import axios from "axios";

export default {
  namespaced: true,
  state: {
    payments: [],
    query: {},
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    paymentsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    CLEAR_PAYMENTS(state) {
      state.payments = [];
    },
    SET_QUERY(state, payload) {
      state.query = Object.assign({}, payload);
    },
    RECEIVED_PAYMENTS(state, payload) {
      state.payments = payload;
      state.isReceiving = false;
    },
    RECEIVED_PAYMENT(state, payload) {
      let find = state.payments.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { payments: [payload, ...state.payments] });
      }
      else {
        let index = state.payments.findIndex(x => x._id === payload._id);
        state.payments.splice(index, 1, payload);
      }
    },
    RECEIVING_PAYMENTS(state) {
      state.isReceiving = true;
    },
    RECEIVING_PAYMENT(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },
    UPDATED_PAYMENT(state, payload) {
      let index = state.payments.findIndex(payment => payment._id === payload._id);
      state = Object.assign(state, {
        payments: state.payments.map((payment, i) => {
          if (i === index) {
            return Object.assign({}, payment, payload);
          }
          return payment;
        }),
        isUpdating: false,
        paymentsMessage: 'Payments has been updating!',
      })
    },
    UPDATING_PAYMENT(state) {
      state.isUpdating = true;
    },
    DELETED_PAYMENT(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.payments.findIndex(payment => payment._id === payload._id);
      console.log(indexToDelete);
      let payments = [...state.payments];
      payments.splice(indexToDelete, 1);
      state = Object.assign(state, {
        payments: [...payments],
        isDeleting: false,
        idToDelete: null,
        paymentsMessage: 'Payment has been Deleted!',
      });
    },
    DELETING_PAYMENT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deletePaymentRequest({dispatch}, payload) {
      dispatch("deletingPayment", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/payment/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        dispatch("deletePayment", {_id: response.data._id});
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deletePaymentTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/delete/pytransaction/" + payload._id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){return null}
    },
    async insertPaymentRequest({dispatch}, payload) {
      try {
        dispatch("receivingPayments");
        var token = localStorage.getItem('token');
        let url = 'https://api.tradexc.com:3000/insert/payment';
        let data = payload;
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        console.log('here2');
        let response = await axios({method: "post", url: url, headers: headers, data: data});
        await dispatch("receivePayment", response.data);
        return response.data;
      } catch (error) {
        console.log(error.data);
      }

    },
    async insertPaymentTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/insert/pytransaction/" + payload.id;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    async getPaymentsRequest({dispatch}) {
      dispatch("receivingPayments");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/payments';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        console.log('payments', response.data)
        dispatch("receivePayments", response.data);
      })
    },
    async getPaymentRequest({dispatch}, id) {
      dispatch("receivingPayments");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/payment/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      let response = await axios({method: "get",url: url,headers: header});
      dispatch("receivePayment", response.data);
      return response.data;
    },
    async findPaymentsRequest({dispatch}, payload) {
      try{
        dispatch("receivingPayments");
        dispatch("setQuery", payload);
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/payments';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receivePayments", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updatePaymentRequest({dispatch}, payload) {
      dispatch("updatingPayment");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/payment/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updatePayment", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updatePaymentTransaction({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/pytransaction/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("receivingPayment", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    clearPayments({commit}) {
      commit("CLEAR_PAYMENTS")
    },
    async setQuery({commit}, payload) {
      commit("SET_QUERY", payload);
    },
    receivePayments({commit}, payload) {
      commit("RECEIVED_PAYMENTS", payload)
    },
    receivingPayments({commit}) {
      commit("RECEIVING_PAYMENTS")
    },
    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },
    receivePayment({commit}, payload) {
      commit("RECEIVED_PAYMENT", payload)
    },
    receivingPayment({commit}) {
      commit("RECEIVING_PAYMENT")
    },
    updatePayment({commit}, payload) {
      commit("UPDATED_PAYMENT", payload)
    },
    updatingPayment({commit}) {
      commit("UPDATING_PAYMENT")
    },
    deletePayment({commit}, payload) {
      commit("DELETED_PAYMENT", payload)
    },
    deletingPayment({commit}, payload) {
      commit("DELETING_PAYMENT", payload)
    }
  },
};
